import React, { useEffect } from "react";
import { notification } from "antd";

/**
 * 全局错误处理组件
 */
export const GlobalErrorHandler: React.FC = () => {
  useEffect(() => {
    // 处理未捕获的Promise错误
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error("Unhandled promise rejection:", event.reason);

      // 根据错误类型显示不同的提示
      if (event.reason?.message) {
        if (event.reason.message.includes("Network Error")) {
          notification.error({
            message: "网络连接失败",
            description: "请检查网络连接后重试",
            duration: 4,
          });
        } else if (event.reason.message.includes("timeout")) {
          notification.warning({
            message: "请求超时",
            description: "服务器响应较慢，请稍后重试",
            duration: 4,
          });
        } else {
          notification.error({
            message: "操作失败",
            description: event.reason.message,
            duration: 4,
          });
        }
      } else {
        notification.error({
          message: "未知错误",
          description: "发生了未知错误，请刷新页面重试",
          duration: 4,
        });
      }

      // 阻止默认的错误处理
      event.preventDefault();
    };

    // 处理未捕获的JavaScript错误
    const handleError = (event: ErrorEvent) => {
      console.error("Uncaught error:", event.error);

      // 只在生产环境显示用户友好的错误提示
      if (process.env.NODE_ENV === "production") {
        notification.error({
          message: "页面出现错误",
          description: "页面遇到了一些问题，请刷新页面重试",
          duration: 4,
        });
      }
    };

    // 添加事件监听器
    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    window.addEventListener("error", handleError);

    // 清理函数
    return () => {
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection,
      );
      window.removeEventListener("error", handleError);
    };
  }, []);

  return null;
};

export default GlobalErrorHandler;
